import { DateTime } from "luxon";

/**
 * Whole years from an ISO birthdate (yyyy-mm-dd) to today, or undefined when the
 * date is missing/unparseable. Shared by the checkout summary and the family
 * session views (CN-1323) so "Age N" is computed identically everywhere.
 */
export const ageFromBirthdate = (iso?: string | null): number | undefined => {
  if (!iso) {
    return undefined;
  }
  const dob = DateTime.fromISO(iso);
  if (!dob.isValid) {
    return undefined;
  }
  return Math.floor(DateTime.now().diff(dob, "years").years);
};
